import React from "react";
import { motion } from "framer-motion";
import "./tools.css";

import one from "../../assets/tools/appachejmeter.png";
import two from "../../assets/tools/appium.png";
import three from "../../assets/tools/appiumjpg.jpg";
import four from "../../assets/tools/cucummber.png";
import five from "../../assets/tools/java.png";
import six from "../../assets/tools/jenkins.png";
import seven from "../../assets/tools/junit.png";
import eight from "../../assets/tools/loadrunner.png";
import nine from "../../assets/tools/postman.png";
import ten from "../../assets/tools/selinium.png";
import elven from "../../assets/tools/sopaui.png";
import twele from "../../assets/tools/testtn.png";



const clients = [
  { src: one, alt: "Apache JMeter" },
  { src: two, alt: "Appium" },
  { src: three, alt: "Appium JPG" },
  { src: four, alt: "Cucumber" },
  { src: five, alt: "Java" },
  { src: six, alt: "Jenkins" },
  { src: seven, alt: "JUnit" },
  { src: eight, alt: "LoadRunner" },
  { src: nine, alt: "Postman" },
  { src: ten, alt: "Selenium" },
  { src: elven, alt: "SoapUI" },
  { src: twele, alt: "TestNG" },
];


function Tools() {
  return (
    <>
      <section style={{ marginTop: "50px" }}>
       <div className="headlines-for-all">
  <h4>
    <span>Tools </span> Covered
  </h4>
  <p>
    Gain hands-on experience with the most in-demand tools used by software
    testing professionals — from automation frameworks and CI/CD pipelines to
    version control and bug-tracking platforms.
  </p>
</div>

      </section>

      <section className="our-clients-section">
        <div className="our-clients-container">
          {/* Motion Scroll (infinite loop) */}
          <motion.div
            className="our-clients-track"
            animate={{ x: ["0%", "-100%"] }}
            transition={{
              ease: "linear",
              duration: 100,
              repeat: Infinity,
            }}
          >
            {[...clients, ...clients].map((client, i) => (
              <div className="client-item" key={i}>
                <img src={client.src} alt={client.alt} />
              </div>
            ))}
          </motion.div>
        </div>
      </section>
    </>
  );
}

export default Tools;
